import { formatDate } from '@angular/common';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static maxDate(max: Date): ValidatorFn {
    return maxDateValidator(max);
  }

  static minDate(min: Date): ValidatorFn {
    return minDateValidator(min);
  }
}

function minDateValidator(min: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value) || !min || isNaN(min.getTime())) {
      return null; // don't validate empty values to allow optional controls
    }
    const value =
      control.value.length === 10
        ? new Date(`${control.value}T00:00`)
        : new Date(control.value);
    // Controls with NaN values after parsing should be treated as not having a
    // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
    return !isNaN(value.getTime()) && value < min
      ? {
          minDate: {
            min: formatDate(min, 'yyyy-MM-dd', 'en'),
            actual: control.value,
          },
        }
      : null;
  };
}

function maxDateValidator(max: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value) || !max || isNaN(max.getTime())) {
      return null; // don't validate empty values to allow optional controls
    }
    const value =
      control.value.length === 10
        ? new Date(`${control.value}T00:00`)
        : new Date(control.value);
    // Controls with NaN values after parsing should be treated as not having a
    // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
    return !isNaN(value.getTime()) && value > max
      ? {
          maxDate: {
            max: formatDate(max, 'yyyy-MM-dd', 'en'),
            actual: control.value,
          },
        }
      : null;
  };
}

function isEmptyInputValue(value: any): boolean {
  /**
   * Check if the object is a string or array before evaluating the length attribute.
   * This avoids falsely rejecting objects that contain a custom length attribute.
   * For example, the object {id: 1, length: 0, width: 0} should not be returned as empty.
   */
  return (
    value == null ||
    ((typeof value === 'string' || Array.isArray(value)) && value.length === 0)
  );
}
